import { StandardEvents } from '@shopify/events';

class SunshadorPurchaseOptions extends HTMLElement {
  connectedCallback() {
    this.style.display = 'block';
    this.controller = new AbortController();
    this.addEventListener('click', (event) => {
      if (this.pending) event.preventDefault();
    }, { signal: this.controller.signal });
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      this.pending = true;
      this.setAttribute('aria-busy', 'true');
      event.promise.then(({ detail }) => {
        if (!this.isConnected || !detail?.html) return;
        const next = detail.html.querySelector('sunshador-purchase-options');
        if (next) this.replaceWith(next);
      }).catch(() => {}).finally(() => {
        this.pending = false;
        this.removeAttribute('aria-busy');
      });
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('sunshador-purchase-options')) {
  customElements.define('sunshador-purchase-options', SunshadorPurchaseOptions);
}

